var E=function(r){return r.HOTEL="hotel",r.PRIVATE_ADDRESS="address",r.UNKNOWN="unknown",r.TRAVEL="travel",r}({});export{E as RequestLocationType};